import React from 'react'
import MonthYearPicker from './MonthYearPicker'

// ─────────────────────────────────────────────────────────────────────────────
//   Desde / hasta, sin encarecer el mes suelto
//
//   `/corporate/overview` acepta `?month=` y `?from=&to=`, y son la misma
//   petición por el mismo código: `month=X` es `from=X&to=X`. Así que la
//   pantalla manda SIEMPRE el rango y no tiene dos caminos que se separen.
//
//   Lo que sí sigue siendo distinto es el gesto: mirar un mes suelto es el caso
//   normal, y con dos selectores independientes pasaría a costar cuatro
//   desplegables en vez de dos. De ahí la única regla de este componente:
//
//     · Los dos extremos NUNCA se cruzan.
//     · Mientras los dos están en el mismo mes se mueven JUNTOS, así que
//       cambiar de mes sigue siendo tocar un control. Se hace rango moviendo
//       "hasta"; una vez que lo es, los extremos se mueven por separado.
//
//   Lo de no cruzarlos no es cosmético: `period_range` en el backend RECHAZA un
//   rango al revés con un 422 en vez de intercambiar los extremos, y con razón
//   —darle la vuelta en silencio contesta una pregunta que nadie hizo—. Pero en
//   dos desplegables el cruce no es una errata, es el estado intermedio normal
//   de quien está eligiendo. Se resuelve colapsando al mes que se acaba de
//   elegir, que es visible en los dos controles a la vez y nunca reinterpreta
//   nada por su cuenta.
//
//   La comparación es de cadena: 'YYYY-MM' con el mes a dos dígitos ordena
//   lexicográficamente igual que cronológicamente. Ni un Date ni el huso del
//   navegador entran en decidir qué mes va antes.
// ─────────────────────────────────────────────────────────────────────────────

export default function MonthRangePicker({ from, to, onChange, idPrefix = 'cf-range' }) {
  const single = from === to

  const setFrom = (next) => {
    // Colapsa cuando ya estaba colapsado (el caso normal) y cuando el nuevo
    // "desde" adelantaría al "hasta".
    if (single || next > to) onChange({ from: next, to: next })
    else onChange({ from: next, to })
  }

  const setTo = (next) => {
    if (next < from) onChange({ from: next, to: next })
    else onChange({ from, to: next })
  }

  return (
    <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
      <MonthYearPicker value={from} onChange={setFrom} idPrefix={`${idPrefix}-from`} labelPrefix="From" />
      <MonthYearPicker value={to} onChange={setTo} idPrefix={`${idPrefix}-to`} labelPrefix="To" />
    </div>
  )
}
